let store = null;
/** Called once at app bootstrap to wire the environment's storage handler. */
export function registerSubmissionsStore(handler) {
    store = handler;
}
export function getSubmissionsStore() {
    if (!store) {
        throw new Error('form-submissions: no store registered — call registerSubmissionsStore() at bootstrap');
    }
    return store;
}
//# sourceMappingURL=store.js.map